import { post, get } from "shared-utils";
import { addError } from "@wayflyer/blackbox-fe";

import type { TabProps } from "../paid-channels-summary/paid-channels-summary-screen";

const notesSavePromise = (updateNotePath: string, newContent: string, title: string) =>
  new Promise((resolve, reject) => {
    post(
      updateNotePath,
      {
        note: {
          content: newContent,
          title,
        },
      },
      () => {
        resolve(null);
      },
      (failureMessage) => {
        addError(new Error(`Error updating note: ${failureMessage}`));
        reject();
      }
    );
  });

export const addNotes = (
  isStaff: boolean,
  notesValue: React.MutableRefObject<string>,
  updateNotePath: string,
  title: string,
  tabData: TabProps[]
): TabProps[] => {
  if (notesValue.current !== "" || isStaff) {
    const notes = { initialText: notesValue.current };

    const notesSaveHandler = (newContent: string): Promise<any> => {
      notesValue.current = newContent;
      return notesSavePromise(updateNotePath, newContent, title);
    };
    const notesUpdateHandler = (newContent: string) => {
      notesValue.current = newContent;
    };

    if (isStaff) {
      notes["saveHandler"] = notesSaveHandler;
      notes["onChangeHandler"] = notesUpdateHandler;
    }

    tabData.push({ title: "Notes", notes });
  }
  return tabData;
};

export const getNotes = (getNotePath: string, title: string, onSuccess: (result: any) => void) => {
  get(`${getNotePath}?note_title=${title}`, onSuccess, (failureMessage: string) => {
    addError(new Error(`Error fetching notes data: ${failureMessage}`));
  });
};
